import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppResource } from "@app/app.resource";
import { ContractEditionComponent } from "@app/views/contract-edition/contract-edition.component";
import { environment } from "@env/environment";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { BaseComponent } from "@shared/components/base/base.component";
import { DocumentsCardComponent } from "@shared/components/documents-card/documents-card.component";
import { MessageServiceComponent } from "@shared/components/message-service/message-service.component";
import { AddressMrhComponent } from "@shared/components/offers/MRH/address-mrh/address-mrh.component";
import { DetailInfoCardMrhComponent } from "@shared/components/offers/MRH/detail-info-card-mrh/detail-info-card-mrh.component";
import { DetailTitleMrhComponent } from "@shared/components/offers/MRH/detail-title-mrh/detail-title-mrh.component";
import { HousingOptionsMrhComponent } from "@shared/components/offers/MRH/housing-options-mrh/housing-options-mrh.component";
import { LessorInformationsMrhComponent } from "@shared/components/offers/MRH/lessor-informations-mrh/lessor-informations-mrh.component";
import { OptionsListMrhComponent } from "@shared/components/offers/MRH/options-list-mrh/options-list-mrh.component";
import { ScholarInsuranceMrhComponent } from "@shared/components/offers/MRH/scholar-insurance-mrh/scholar-insurance-mrh.component";
import { ServiceOfferingsMrhComponent } from "@shared/components/offers/MRH/service-offerings-mrh/service-offerings-mrh.component";
import { DetailInfoCardPjComponent } from "@shared/components/offers/PJ/detail-info-card-pj/detail-info-card-pj.component";
import { DetailTitlePjComponent } from "@shared/components/offers/PJ/detail-title-pj/detail-title-pj.component";
import { OptionsListPJComponent } from "@shared/components/offers/PJ/options-list-pj/options-list-pj.component";
import { ServiceOfferingsPjComponent } from "@shared/components/offers/PJ/service-offerings-pj/service-offerings-pj.component";
import { TitlePjComponent } from "@shared/components/offers/PJ/title-pj/title-pj.component";
import { DeclarationSaComponent } from "@shared/components/offers/SA/declaration-sa/declaration-sa.component";
import { DetailTitleSaComponent } from "@shared/components/offers/SA/detail-title-sa/detail-title-sa.component";
import { MedicalHistorySaComponent } from "@shared/components/offers/SA/medical-history-sa/medical-history-sa.component";
import { OptionsListSAComponent } from "@shared/components/offers/SA/options-list-sa/options-list-sa.component";
import { ServiceOfferingsSaComponent } from "@shared/components/offers/SA/service-offerings-sa/service-offerings-sa.component";
import { TitleSaComponent } from "@shared/components/offers/SA/title-sa/title-sa.component";
import { PaymentInformationsComponent } from "@shared/components/payment-informations/payment-information.component";
import { PopupDialogComponent } from "@shared/components/popup-dialog/popup-dialog.component";
import { StatusCardComponent } from "@shared/components/status-card/status-card.component";
import { WarrantyOptionsMrhComponent } from "@shared/components/warranty-options-mrh/warranty-options-mrh.component";
import {
  ERROR_SEVERITY,
  ERROR_SUMMARY_MESSAGE_KEY,
  SUCCESS_SEVERITY,
  SUCCESS_SUMMARY_MESSAGE_KEY,
} from "@shared/constants/message-service.constants";
import { NOM_ANI } from "@shared/constants/risk-item-fields.constants";
import { ID, ID_PARAM } from "@shared/constants/route-variables.constants";
import { NOUS_CONTACTER, RECEIPTSDETAIL } from "@shared/constants/route.constants";
import { Branches } from "@shared/enums/branches";
import { DocumentType } from "@shared/enums/documents.type";
import { FormulasOptions } from "@shared/enums/formulas-options";
import { PackagesType } from "@shared/enums/packages-type";
import { PolicyStates } from "@shared/enums/policy-states";
import { RequestNatureOptions } from "@shared/enums/request-nature-options";
import { Address } from "@shared/models/address";
import { GdaTypes } from "@shared/models/contract-options-state.model";
import { DocumentsVm, LessorDataDto, PolicyDetail, SchoolInsuredChild } from "@shared/models/policy-details";
import { DocumentName } from "@shared/models/quotation";
import { StatusConfig } from "@shared/models/status-config.model";
import { OffersTypeService } from "@shared/services/offers-type.service";
import { PolicyRecoveryService } from "@shared/services/policy-recovery.service";
import { PolicyStatusService } from "@shared/services/policy-status.service";
import { PolicyService } from "@shared/services/policy.service";
import { isNavigationButtonVisible, isPartner } from "@shared/utils/brand-utils";
import { Guid } from "guid-typescript";
import { ButtonModule } from "primeng/button";
import { DividerModule } from "primeng/divider";
import { TabViewModule } from "primeng/tabview";
import { lastValueFrom } from "rxjs";
import { DetailInfoCardSaComponent } from "../../shared/components/offers/SA/detail-info-card-sa/detail-info-card-sa.component";

@Component({
  selector: "app-contract-detail",
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    TranslateModule,
    TabViewModule,
    DocumentsCardComponent,
    ScholarInsuranceMrhComponent,
    LessorInformationsMrhComponent,
    ServiceOfferingsMrhComponent,
    LessorInformationsMrhComponent,
    PaymentInformationsComponent,
    ServiceOfferingsMrhComponent,
    PopupDialogComponent,
    DetailTitleMrhComponent,
    AddressMrhComponent,
    StatusCardComponent,
    DetailInfoCardMrhComponent,
    OptionsListMrhComponent,
    ScholarInsuranceMrhComponent,
    HousingOptionsMrhComponent,
    ContractEditionComponent,
    MessageServiceComponent,
    ServiceOfferingsPjComponent,
    DetailTitlePjComponent,
    TitlePjComponent,
    DetailInfoCardPjComponent,
    OptionsListPJComponent,
    DividerModule,
    TitleSaComponent,
    DetailTitleSaComponent,
    ServiceOfferingsSaComponent,
    OptionsListSAComponent,
    DetailInfoCardSaComponent,
    DeclarationSaComponent,
    MedicalHistorySaComponent,
    WarrantyOptionsMrhComponent,
  ],
  templateUrl: "./contract-detail.component.html",
  styleUrl: "./contract-detail.component.scss",
})
export class ContractDetailComponent extends BaseComponent implements OnInit {
  reference!: string;
  policyId!: Guid;
  policyDetails!: PolicyDetail;
  fSDocument!: DocumentsVm;
  isGdaAllowed = false;
  policyStatusConfigStatus!: Record<string, StatusConfig>;
  activeIndex = 0;
  child!: SchoolInsuredChild[];
  lessor!: LessorDataDto;
  lessorDateTerminationLetter!: string;
  promotionCode = "";
  isMenuOpen = false;
  // isMrhBranch = false;
  // isPJBranch = false;
  // isSaBranch = false;
  isConfortProduct!: boolean;

  branches = Branches;
  addressData!: Address;
  policyStates = PolicyStates;
  isValidPolicyState = false;

  messageId!: Guid;
  severityMessage!: string;
  summaryMessage!: string;
  detailMessage!: string;

  isPolicyWaitingForSignature = false;
  isPolicyActive = false;

  animalName!: string;
  options = FormulasOptions;
  requestTermination = RequestNatureOptions.Termination;

  documentTypes: DocumentName[] = [
    {
      type: DocumentType.ATTASSU,
      name: "document.homeInsuranceCertificate",
    },
    {
      type: DocumentType.ATTSCO,
      name: "document.childSchoolCertificate",
    },
    {
      type: DocumentType.FS,
      name: "document.fs",
    },
    {
      type: DocumentType.AVIECHEANCE,
      name: "document.avisEcheance",
    },
    {
      type: DocumentType.CG,
      name: "document.conditionsGenerales",
    },
    {
      type: DocumentType.CP,
      name: "document.specialConditions",
    },
    {
      type: DocumentType.FIC,
      name: "document.ficheInformationEtConseil",
    },
    {
      type: DocumentType.SEPA,
      name: "document.sepaMandate",
    },
  ];

  visibleDialog = false;
  visibleContractEditionDialog = false;
  editPersonnalData = false;
  saveMessage = { header: "", message: "" };
  packageType = PackagesType;
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly policyStatusService: PolicyStatusService,
    private readonly translate: TranslateService,
    private readonly policyService: PolicyService,
    private readonly policyRecovery: PolicyRecoveryService,
    private readonly offerTypeService: OffersTypeService,
    resources: AppResource
  ) {
    super(resources);
  }

  ngOnInit() {
    this.policyId = this.route.snapshot.params[ID];
    this.policyStatusConfigStatus = this.policyStatusService.getStatusConfig();
    this.loadPolicyDetails();
  }

  resetView() {
    this.router.navigate([".."]);
  }

  loadPolicyDetails() {
    this.policyService.getPolicyDetails(this.policyId).subscribe({
      next: policyDetails => {
        this.policyDetails = policyDetails;
        this.fSDocument =
          policyDetails.documents.find(doc => doc.documentTypeCode === DocumentType.FS) || ({} as DocumentsVm);
        this.reference = this.policyDetails.reference;
        this.fillAddressData();
        this.child = policyDetails.schoolInsuredChildsVM.childrenList;
        this.lessor = policyDetails.optionalServicePolicyVm.lessorData!;
        this.lessorDateTerminationLetter = this.policyDetails.optionalServicePolicyVm.dateSentTerminationLetter;
        this.isGdaAllowed =
          this.policyDetails.gda === GdaTypes.False_Positive ||
          this.policyDetails.gda === GdaTypes.Confirmed_Authorized ||
          this.policyDetails.gda === GdaTypes.Error ||
          this.policyDetails.gda === null;
        this.isBranchMRH = this.offerTypeService.isPolicyDetailsBranch(this.policyDetails, Branches.MRH);
        if (!this.isBranchMRH) {
          this.isBranchPJ = this.offerTypeService.isPolicyDetailsBranch(this.policyDetails, Branches.PJ);
          if (!this.isBranchPJ) {
            this.fillSaData();
            this.isBranchSA = this.offerTypeService.isPolicyDetailsBranch(this.policyDetails, Branches.SA);
          }
        }
        this.isPolicyWaitingForSignature = this.policyStatusService.isPolicyWaitingForSignature(this.policyDetails);
        this.isPolicyActive = this.policyStatusService.isPolicyActive(this.policyDetails);
        this.isValidPolicyState =
          this.policyDetails.status === this.policyStates.Signed ||
          this.policyDetails.status === this.policyStates.Ongoing ||
          this.policyDetails.status === this.policyStates.Temporary ||
          this.policyDetails.status === this.policyStates.Unpaid ||
          this.policyDetails.status === this.policyStates.Suspended;

        const formulaCode = this.policyDetails.formulasAndOptionsInformations.formulaCode;
        this.isConfortProduct = formulaCode === PackagesType.Confort || formulaCode === PackagesType.ConfortPlus;
      },
    });
  }

  fillAddressData() {
    if (this.policyDetails) {
      this.addressData = {
        address: this.policyDetails.address,
        postalCode: this.policyDetails.postalCode,
        city: this.policyDetails.city,
      };
    }
  }

  fillSaData() {
    if (this.policyDetails) {
      this.animalName = this.policyDetails.riskItemInformations?.values.find(ri => ri.code === NOM_ANI)?.value || "";
    }
  }

  activeIndexChange(event: any) {
    this.activeIndex = event.index;
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  async showPopup() {
    const translations = await lastValueFrom(this.translate.get(["modifyPolicy.header", "modifyPolicy.message"]));

    this.saveMessage.header = translations["modifyPolicy.header"];
    this.saveMessage.message = `<br/>
      ${translations["modifyPolicy.message"]}<br/>
    `;
    this.visibleDialog = true;
  }

  onContractEditionClose() {
    this.visibleContractEditionDialog = false;
  }

  onUpdateValidation(event: boolean) {
    this.messageId = Guid.create();
    if (event) {
      this.severityMessage = SUCCESS_SEVERITY;
      this.summaryMessage = this.translate.instant(SUCCESS_SUMMARY_MESSAGE_KEY);
      this.detailMessage = this.translate.instant("common.messages.saveSuccess");
    } else {
      this.severityMessage = ERROR_SEVERITY;
      this.summaryMessage = this.translate.instant(ERROR_SUMMARY_MESSAGE_KEY);
      this.detailMessage = this.translate.instant("common.messages.saveError");
    }
  }

  onContractEditionValidate(event: boolean) {
    this.visibleDialog = false;
    this.editPersonnalData = event;
    this.visibleContractEditionDialog = true;
  }

  onContractAction() {
    if (this.policyDetails && this.policyDetails.status === PolicyStates.Wait4Sign) {
      this.policyRecovery.getSignatureUrl(this.policyDetails);
    }
  }

  goToContactUs() {
    const policyId = this.policyId;
    const requestNature = this.requestTermination;
    this.router.navigate([NOUS_CONTACTER], {
      queryParams: { policyId, requestNature },
    });
  }

  goToPaymentSchedule() {
    const receiptsDetailPath = RECEIPTSDETAIL.replace(ID_PARAM, this.policyId.toString());
    this.router.navigate([receiptsDetailPath]);
  }

  isButtonVisible(buttonType: any): boolean {
    return isNavigationButtonVisible(buttonType);
  }

  getOptionPJOnContract(): boolean {
    return !!this.policyDetails.formulasAndOptionsInformations.options?.find(
      option => option.type === this.options.PJSOL
    );
  }

  isPartner(): boolean {
    return isPartner(environment);
  }
}
